// tooltip.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  @Input() text: string = '';
  @Input() position: 'top' | 'right' | 'bottom' | 'left' = 'top';
  show = false;

  get positionClass() {
    switch (this.position) {
      case 'top':
        return 'bottom-full mb-2 left-1/2 transform -translate-x-1/2';
      case 'right':
        return 'left-full ml-2 top-1/2 transform -translate-y-1/2';
      case 'bottom':
        return 'top-full mt-2 left-1/2 transform -translate-x-1/2';
      case 'left':
        return 'right-full mr-2 top-1/2 transform -translate-y-1/2';
      default:
        return '';
    }
  }
}
